import Vue from 'vue'
import AgGridColumnMethodMixins from '@/Mixins/SigmaClientNew/AgGridColumnMethods'

/*
* AG Grid Column Defs here
*/
export default Vue.extend({
  mixins: [AgGridColumnMethodMixins],

  data () {
    return {
      ddDepositAccountColumn: {
        headerName: 'Account',
        field: 'employee_account_number',
        colId: 'employee_account_number',
        maxWidth: 300,
        minWidth: 200,
        editable: false,
        sortable: true,
        valueGetter: (params) => params.data ? params.data.account_number : '',
        valueSetter: () => null
      },

      ddDepositRoutingColumn: {
        headerName: 'Routing',
        field: 'employee_routing_number',
        colId: 'employee_routing_number',
        maxWidth: 300,
        minWidth: 200,
        editable: false,
        sortable: true,
        valueGetter: (params) => params.data ? params.data.routing_number : '',
        valueSetter: () => null
      },

      ddIsSavingsColumn: {
        headerName: 'Savings',
        field: 'is_savings_account',
        colId: 'is_savings_account',
        maxWidth: 100,
        minWidth: 20,
        editable: false,
        sortable: true,
        valueGetter: (params) => params.data && params.data.is_savings_account ? 'Y' : 'N',
        valueSetter: () => null
      },

      ddAmountColumn: {
        headerName: 'Amount',
        field: 'amount_decimal',
        colId: 'amount_decimal',
        maxWidth: 150,
        minWidth: 100,
        editable: false,
        cellClass: 'amount',
        sortable: true,
        aggFunc: 'sum',
        valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
        valueGetter: (params) => params.data ? params.data.amount_decimal : '',
        valueSetter: () => null
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/Mixins/SigmaClientNew/AgGridDDColumns.js